import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Divider, Space, Button, Row, Col, Flex } from "antd";
import { useEffect } from "react";
import { setModalDeletarLote } from "../../../../../../redux/slices/pagamentoContaFinanceira/pagamentoContaFinanceiraSlice";
import { buscarContaBanco } from "../../../../../../services/contaBancoService";
import { buscarFormaPagamentoRecebimento } from "../../../../../../services/formaPagamentoRecebimentoService";
import { buscarPagamentoLote, deletarTodosPagamentoLote } from "../../../../../../services/pagamentoLoteService";
import { currencyBRL } from "../../../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../../../util/hooks";
import { Vm_ContaBancoModel } from "../../../../../../models/contaBanco/vm_contaBancoModel";
import TableComponent from "../../../../../../components/table/tableComponent";
import { ColumnsType } from "antd/lib/table";
import { PagamentoLoteModel } from "../../../../../../models/pagamentoLote/pagamentoLoteModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");

const DeletarPagamentoLote = () => {
  //estados globais
  const pagamentoContaFinanceiraState = useAppSelector((state) => state.pagamentoContaFinanceira);
  const pagamentoLote = useAppSelector((state) => state.pagamentoLote);
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);
  const contaBancoState = useAppSelector((state) => state.contaBanco);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  useEffect(() => {
    dispatch(buscarPagamentoLote(pagamentoContaFinanceiraState.entity.idPagamentoLote));
    dispatch(buscarContaBanco(contaBancoState.busca));
    dispatch(buscarFormaPagamentoRecebimento(formaPagamentoRecebimentoState.busca));
  }, [pagamentoContaFinanceiraState.entity]);

  const deletar = () => {
    dispatch(deletarTodosPagamentoLote({ value: pagamentoContaFinanceiraState.entity.idPagamentoLote, busca: pagamentoContaFinanceiraState.entity.idPagamentoLote }));
  };

  const voltar = () => {
    dispatch(setModalDeletarLote(false));
  };

  const columns: ColumnsType<PagamentoLoteModel> = [
    {
      title: "DATA PAGAMENTO",
      dataIndex: "data",
      render: (_, record) => <>{dayjs(record.data).format("DD/MM/YYYY")}</>,
    },
    {
      title: "CONTA BANCO",
      dataIndex: "idContaBanco",
      render: (_, record) => <>{contaBancoState.list.find((a: Vm_ContaBancoModel) => a.id === record.idContaBanco)?.denominacaoPersonalizada}</>,
    },
    {
      title: "FORMA PAGAMENTO",
      dataIndex: "idFormaPagamentoRecebimento",
      render: (_, record) => <>{formaPagamentoRecebimentoState.list.find((a: any) => a.id === record.idFormaPagamentoRecebimento)?.denominacao}</>,
    },
    // {
    //   title: "VALOR",
    //   dataIndex: "valor",
    //   align: "right",
    //   render: (_, record) => <>{record.valor && currencyBRL(record.valor)}</>,
    // },
    // {
    //   title: "JUROS",
    //   dataIndex: "juros",
    //   align: "right",
    //   render: (_, record) => <>{record.juros && currencyBRL(record.juros)}</>,
    // },
    // {
    //   title: "MULTA",
    //   dataIndex: "multa",
    //   align: "right",
    //   render: (_, record) => <>{record.multa && currencyBRL(record.multa)}</>,
    // },
    // {
    //   title: "OUTROS VALORES",
    //   dataIndex: "outrosValores",
    //   align: "right",
    //   render: (_, record) => <>{record.outrosValores && currencyBRL(record.outrosValores)}</>,
    // },
    // {
    //   title: "DESCONTO",
    //   dataIndex: "desconto",
    //   align: "right",
    //   render: (_, record) => <>{record.desconto && currencyBRL(record.desconto)}</>,
    // },
    {
      title: "VALOR TOTAL",
      dataIndex: "valorTotal",
      align: "right",
      render: (_, record) => <>{record.valorTotal && currencyBRL(record.valorTotal)}</>,
    },
  ];

  return (
    <Flex vertical>
      <TableComponent data={pagamentoLote.list} columns={columns} loading={pagamentoLote.loading} />
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              NÃO
            </Button>
            <Button className="buttonPrimary" onClick={deletar} icon={<CheckOutlined />}>
              SIM
            </Button>
          </Space>
        </Col>
      </Row>
    </Flex>
  );
};
export default DeletarPagamentoLote;
